import * as React from "react";
import { User } from "./../models/users";
import { RLink } from "./RLink";

export class LinkToUser extends React.Component<
  {
    linkUser: { username: string };
    currentUser?: User;
  },
  {}
> {
  render(): JSX.Element {
    const { currentUser, linkUser } = this.props;

    if (
      this.props.linkUser.username.toLowerCase().indexOf("anonymous") !== -1 ||
      this.props.linkUser.username.toLowerCase().indexOf("song author") !== -1
    ) {
      return <span className="text-slate-500 dark:text-slate-400">Anonymous Chip</span>;
    }

    const usernameToShow =
      currentUser && currentUser.username === linkUser.username
        ? "you"
        : linkUser.username;

    return (
      <RLink white to={`/user/${this.props.linkUser.username}`}>
        {usernameToShow}
      </RLink>
    );
  }
}
